// extracted by mini-css-extract-plugin
export default {"authorsLine":"RlSVo1yyINvbwsj5E850"};